import React from 'react';

export const RadioMultiButton = ({fieldOpts, fieldName, fieldsetId, checkedVal, handleMultiChange, errMessage, legend, required}) => {
	return(
		<fieldset
			id={fieldsetId} 
			className="radio-multi-button"
			role="radiogroup" 
			aria-labelledby={fieldName + "Label"}>
			<legend id={fieldName + "Label"}>
				{legend}
				{required ? ("(Choose One)*") : (false)}
			</legend>
			{(fieldOpts).map((fieldOpt, index) => (
					<label 
						key={index}
						className={checkedVal === fieldOpt.value ? 'checked' : ''} 
						htmlFor={`${fieldName}${index}`}>
						<input 
							className="radio-button"
							type="radio" 
							name={fieldName} 
							id={`${fieldName}${index}`} 
							value={fieldOpt.value} 
							checked={checkedVal === fieldOpt.value}
							aria-checked={checkedVal === fieldOpt.value}
							onChange={handleMultiChange} />
					
						{ //Check if secondLine is null
							(fieldOpt.secondLine)
							? <div className="radioBtnContainer">{fieldOpt.label}<br/>{fieldOpt.secondLine}<span className="checkmark">&#x2713;</span></div> 
							: <div>{fieldOpt.label}<span className="checkmark">&#x2713;</span></div>
						}
					</label>
			))}
			<span className="form-error">
	    		<p>{errMessage}</p>
	    	</span>
		</fieldset>
	)
};


// WEBPACK FOOTER //
// ./src/components/RadioMultiButton/RadioMultiButton.js